import { styled } from 'styled-components'
import { Link } from 'react-router-dom'
import media from 'common-ui-components/src/vtj/theme/media'
import { responsiveMaxWidth } from 'common-ui-components/src/vtj/theme/helpers'
import {
  IconLogin as SuomifiLoginIcon,
  Block,
  LanguageMenu,
} from 'suomifi-ui-components'
import { DefaultTheme } from 'styled-components/dist/types'

export const PageHeader = styled(Block)`
  background-color: ${(props) => props.theme.colors.brandBase};
`

export const TitleLink = styled(Link)`
  ${(props) => props.theme.typography.heading3};
  color: ${(props) => props.theme.colors.whiteBase};
  line-height: 40px;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  &:visited {
    color: ${(props) => props.theme.colors.whiteBase};
  }
  ${media.mobileContent} {
    margin-right: auto;
  }
`

export const InnerHeader = styled(Block)`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.spacing.s} ${theme.spacing.m}`};
  ${responsiveMaxWidth()};
  ${media.mobileAndTablet} {
    padding: ${({ theme }) =>
      `${theme.spacing.m} ${theme.spacing.s} ${theme.spacing.m} 0`};
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;
  }
  ${media.mobileContent} {
    padding-left: ${({ theme }) => theme.spacing.s};
  }
`

export const ProfileMenu = styled(Block)`
  ${(props) => props.theme.typography.actionElementInnerTextBold};
  color: ${(props) => props.theme.colors.whiteBase};
  display: flex;
  flex-direction: row;
  line-height: 1em;
  white-space: nowrap;
  text-align: right;
  justify-content: end;
  margin-left: auto;
  ${media.mobileAndTablet} {
    flex-wrap: wrap;
    width: 100%;
    margin-top: ${(props) => props.theme.spacing.xxs};
  }
`

export const UserInfo = styled(Block)`
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: baseline;
  div {
    ${(props) => props.theme.typography.actionElementInnerTextBoldSmallScreen}
    color: ${(props) => props.theme.colors.whiteBase};
  }
  a {
    ${(props) => props.theme.typography.actionElementInnerTextBold}
    color: ${(props) => props.theme.colors.whiteBase} !important;
    display: inline-block;
    font-size: 12px;
    text-transform: uppercase;
    &:visited {
      color: ${(props) => props.theme.colors.whiteBase} !important;
    }
  }
  ${media.mobileAndTablet} {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`

export const LoginIcon = styled(SuomifiLoginIcon)`
  margin-right: 8px;
  margin-bottom: 2px;
  vertical-align: middle;
`

export const LoginButtonLink = styled.a<{ theme: DefaultTheme }>`
  ${(props) => props.theme.typography.actionElementInnerTextBold};
  display: inline-block;
  &:hover {
    text-decoration: none;
  }
  &:visited {
    color: #fff;
  }
  border-radius: ${(props) => props.theme.radiuses.basic};
  border: 1px solid ${(props) => props.theme.colors.whiteBase};
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  min-height: 40px;
  padding: ${(props) => `${props.theme.spacing.xs} ${props.theme.spacing.m}`};
  text-align: center;
  ${media.mobileAndTablet} {
    width: 100%;
    margin-top: 8px;
    flex-basis: 100%;
  }
`

export const TestAuthenticatorButton = styled(LoginButtonLink)`
  margin-left: ${(props) => props.theme.spacing.m};
  background: rgb(0, 127, 100);
  ${media.mobileAndTablet} {
    margin-left: 0;
  }
`

export const LanguageWrapper = styled(Block)`
  display: flex;
  justify-self: flex-end;
  ${media.desktop} {
    order: 1;
    margin-left: ${(props) => props.theme.spacing.xl};
  }
  ${media.mobileAndTablet} {
    margin-left: auto;
  }
`

export const StyledLanguageMenu = styled(LanguageMenu)`
  &&&&& .fi-language-menu_button {
    padding-right: 0;
    background-color: ${(props) => props.theme.colors.brandBase};
    color: ${(props) => props.theme.colors.whiteBase};
    border-color: transparent;
  }

  &&&&& .fi-language-menu_button_icon {
    color: ${(props) => props.theme.colors.whiteBase};
    path {
      fill: ${(props) => props.theme.colors.whiteBase};
    }
  }
`

export const DvvIcon = styled.img`
  height: 38px;
  margin-right: 10px;
  display: none;
  ${media.mobileAndTablet} {
    display: inline-block;
  }
`

export const DvvLogo = styled.img`
  margin-left: -32px; /* This is specific to the svg content =/ */
  margin-right: 10px;
  height: 70px;
  display: inline-block;
  ${media.mobileAndTablet} {
    display: none;
  }
`
